var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighFiveHandsBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 300,
    viewBox: "0 0 301 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.794 28.602C198.794 28.602 150.65 10.668 103.946 37.668C57.2418 64.668 34.1898 119.136 14.3478 162.75C-5.49417 206.364 6.79983 251.148 42.9618 271.95C79.1238 292.752 103.178 263.064 153.536 262.242C203.894 261.42 217.538 268.914 258.98 240.498C300.422 212.082 307.136 143.826 273.53 92.832C239.924 41.838 198.794 28.602 198.794 28.602Z",
    fill: "#657B8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M198.794 28.602C198.794 28.602 150.65 10.668 103.946 37.668C57.2418 64.668 34.1898 119.136 14.3478 162.75C-5.49417 206.364 6.79983 251.148 42.9618 271.95C79.1238 292.752 103.178 263.064 153.536 262.242C203.894 261.42 217.538 268.914 258.98 240.498C300.422 212.082 307.136 143.826 273.53 92.832C239.924 41.838 198.794 28.602 198.794 28.602Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.902 170.21L233.709 178.402L241.902 186.595L250.095 178.402L241.902 170.21Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1989 25.4079L57.0063 33.6004L65.1989 41.7929L73.3914 33.6004L65.1989 25.4079Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3128 196.249L45.2471 201.315L50.3128 206.38L55.3785 201.315L50.3128 196.249Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6819 114.03L16.6162 119.096L21.6819 124.161L26.7476 119.096L21.6819 114.03Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8 55.3927L223.734 60.4584L228.8 65.5241L233.866 60.4584L228.8 55.3927Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6723 201.882L54.4683 209.086L61.6723 216.29L68.8763 209.086L61.6723 201.882Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.341 194.201L200.275 199.267L205.341 204.332L210.407 199.267L205.341 194.201Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.203 45.0459L234.508 54.7403L244.203 64.4347L253.897 54.7403L244.203 45.0459Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.301 273.963L135.235 279.028L140.301 284.094L145.367 279.028L140.301 273.963Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4269 121.14C43.4929 121.14 46.7889 117.844 46.7889 113.778C46.7889 109.712 43.4929 106.416 39.4269 106.416C35.361 106.416 32.0649 109.712 32.0649 113.778C32.0649 117.844 35.361 121.14 39.4269 121.14Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.95 143.634C256.79 143.634 259.904 140.521 259.904 136.68C259.904 132.839 256.79 129.726 252.95 129.726C249.109 129.726 245.996 132.839 245.996 136.68C245.996 140.521 249.109 143.634 252.95 143.634Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.897 92.916C280.157 92.916 281.989 91.084 281.989 88.824C281.989 86.5641 280.157 84.732 277.897 84.732C275.637 84.732 273.805 86.5641 273.805 88.824C273.805 91.084 275.637 92.916 277.897 92.916Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.099 35.238C196.1 34.751 195.957 34.2745 195.687 33.8691C195.417 33.4636 195.033 33.1474 194.583 32.9604C194.134 32.7735 193.639 32.7243 193.161 32.819C192.683 32.9137 192.244 33.1482 191.9 33.4926C191.555 33.8369 191.321 34.2758 191.226 34.7536C191.131 35.2313 191.181 35.7265 191.368 36.1762C191.555 36.626 191.871 37.0101 192.276 37.2799C192.682 37.5498 193.158 37.6932 193.645 37.692C194.296 37.692 194.92 37.4335 195.38 36.9733C195.841 36.5131 196.099 35.8889 196.099 35.238Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0131 177.588C94.3684 177.588 95.4671 176.489 95.4671 175.134C95.4671 173.779 94.3684 172.68 93.0131 172.68C91.6578 172.68 90.5591 173.779 90.5591 175.134C90.5591 176.489 91.6578 177.588 93.0131 177.588Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9272 244.674C36.9618 244.674 38.6112 243.025 38.6112 240.99C38.6112 238.955 36.9618 237.306 34.9272 237.306C32.8925 237.306 31.2432 238.955 31.2432 240.99C31.2432 243.025 32.8925 244.674 34.9272 244.674Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.857 234.852C257.857 234.204 257.665 233.57 257.305 233.031C256.944 232.492 256.432 232.073 255.833 231.825C255.234 231.577 254.575 231.512 253.94 231.639C253.304 231.766 252.72 232.079 252.263 232.538C251.805 232.996 251.493 233.581 251.367 234.217C251.242 234.852 251.307 235.511 251.556 236.11C251.805 236.708 252.226 237.22 252.765 237.579C253.305 237.938 253.939 238.129 254.587 238.128C255.017 238.128 255.443 238.043 255.84 237.879C256.237 237.714 256.598 237.472 256.902 237.168C257.205 236.864 257.446 236.503 257.61 236.105C257.774 235.708 257.858 235.282 257.857 234.852Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.679 23.4C231.681 22.7518 231.489 22.1179 231.13 21.5783C230.771 21.0388 230.26 20.618 229.661 20.3691C229.063 20.1202 228.404 20.0545 227.768 20.1802C227.132 20.306 226.548 20.6175 226.089 21.0754C225.63 21.5333 225.318 22.117 225.191 22.7527C225.064 23.3883 225.128 24.0473 225.376 24.6463C225.624 25.2453 226.044 25.7572 226.583 26.1175C227.122 26.4777 227.755 26.67 228.403 26.67C228.833 26.6708 229.259 26.5868 229.657 26.4228C230.054 26.2588 230.415 26.0181 230.72 25.7144C231.024 25.4106 231.265 25.0499 231.43 24.6528C231.595 24.2556 231.679 23.8299 231.679 23.4Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.784 148.956L77.4683 161.634",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6064 79.824L81.5604 89.64",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4683 24.192L102.422 49.962",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.871 12.738L140.055 33.192",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.502 61.416L208.364 40.554",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216.542 103.548L234.542 97.416",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.364 149.364L214.496 157.95",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1528 61.008L93.4228 70.416",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.273 78.6L200.181 84.732",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6463 123.186L71.7383 127.272",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.088 128.502L211.634 130.14",
    stroke: "#263238",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M210.692 104.148C208.376 102.546 199.664 103.968 194.15 108.414C188.636 112.86 187.394 114.462 187.394 114.462C187.394 114.462 184.904 97.032 184.904 96.498C184.904 95.964 181.346 63.24 180.632 58.44C179.918 53.64 178.832 46.524 177.788 44.922C176.744 43.32 172.454 43.122 171.032 43.86L169.61 44.568C169.61 44.568 170.318 32.118 168.896 29.094C167.474 26.07 163.028 27.852 161.78 29.454C160.893 30.7162 160.177 32.0901 159.65 33.54C159.65 33.54 155.558 32.118 153.248 36.744C150.938 41.37 149.156 45.456 148.802 49.902C148.448 54.348 146.486 60.042 146.486 60.042C146.486 60.042 144.176 56.304 141.686 58.44C139.196 60.576 136.352 68.934 135.638 74.982C134.924 81.03 134.216 97.032 134.216 97.032C134.216 97.032 132.794 104.322 132.08 110.196C131.366 116.07 131.906 140.43 134.57 150.564C137.234 160.698 140.798 167.106 140.798 167.106C140.798 167.106 147.02 187.554 147.908 190.404C148.796 193.254 158.582 232.02 158.582 232.02L187.748 195C187.748 195 180.458 174.906 178.856 170.28C177.254 165.654 176.186 164.232 176.186 164.232C176.186 164.232 185.078 151.632 189.884 147.87C194.69 144.108 197.174 131.67 198.416 126.174C199.658 120.678 204.818 113.016 207.668 110.526C210.518 108.036 213.002 105.75 210.692 104.148ZM144.884 95.61C144.356 95.61 144.53 88.674 144.53 80.316C144.53 71.958 145.952 68.22 145.952 68.22C145.244 71.958 146.666 90.45 146.666 91.698C146.666 92.946 145.418 95.61 144.884 95.61Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.782 167.298C174.008 166.17 174.41 164.97 174.41 164.97",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.31 163.2C154.31 163.2 164.096 169.602 168.896 168.354",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.394 114.462C187.394 114.462 183.656 120.33 182.768 122.466C181.88 124.602 181.346 126.378 179.768 127.266C178.19 128.154 176.036 129.402 176.036 129.402",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.648 116.202C172.124 118.302 165.758 122.01 162.14 127.446",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M181.88 114.108C181.88 114.108 180.572 114.51 178.592 115.308",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160.184 129.756C160.184 129.756 156.98 135.624 155.558 140.25",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M159.65 33.54C159.65 33.54 158.756 41.01 157.514 52.2C156.272 63.39 155.558 68.916 155.714 76.032C155.87 83.148 157.868 89.4 157.7 90.276",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M169.61 44.568C169.284 48.1186 169.284 51.6915 169.61 55.242C170.138 61.284 169.076 72.492 169.076 76.758C169.076 81.024 169.25 87.432 169.43 89.358C169.556 90.5698 169.983 91.7308 170.672 92.736",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M172.988 93.834C172.988 93.834 173.876 95.43 179.744 95.634",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 89.562C159.5 89.562 163.766 90.45 166.616 89.922",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M143.996 97.032C143.996 97.032 143.996 98.832 138.842 100.41",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154.136 92.232C154.67 91.878 156.8 91.164 157.334 88.674",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M154.442 119.472C154.442 119.472 165.5 115.422 172.502 113.946",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M185.834 299.484H281.438C274.76 290.67 250.394 258.552 248.804 256.962C246.962 255.12 238.85 254.016 238.85 254.016L214.892 234.108L185.036 184.716L156.65 224.16L151.85 204.96L141.17 244.8C141.17 244.8 179.876 291.984 181.37 293.826C181.634 294.18 183.302 296.298 185.834 299.484Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110.972 161.208C110.972 161.208 103.058 140.94 101.15 137.208C99.2418 133.476 88.8859 117.27 88.3639 112.878C87.8419 108.486 86.2218 101.166 84.5538 98.106C82.8858 95.046 87.8538 93.042 91.9578 96.906C96.0618 100.77 98.5579 107.106 98.4979 108.906C98.4379 110.706 107.714 117.516 107.714 117.516L109.4 101.916C109.4 101.916 111.2 63.162 110.822 57.378C110.444 51.594 110.072 39.312 114.662 38.838C119.252 38.364 119.96 42 119.96 42C119.96 42 120.128 32.844 125.228 33.438C129.128 33.888 130.628 37.566 131.192 39.33C131.756 41.094 132.434 43.302 132.434 43.302C132.434 43.302 135.65 41.118 138.788 46.302C140.588 49.302 144.416 58.686 145.034 61.074C145.652 63.462 145.844 64.326 145.844 64.326C147.198 64.3609 148.512 64.7976 149.618 65.5807C150.723 66.3638 151.571 67.4579 152.054 68.724C153.962 73.266 156.674 85.122 159.296 94.92C160.901 101.168 161.745 107.586 161.81 114.036C161.81 114.036 162.836 145.578 160.724 155.61C158.612 165.642 154.64 174.21 153.824 175.008C153.008 175.806 141.278 210.456 141.278 210.456L100.574 195.366C100.574 195.366 109.052 174.54 110.39 169.998C111.195 167.141 111.393 164.146 110.972 161.208Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.452 131.64C102.48 132.718 102.654 133.788 102.968 134.82",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M106.466 119.244C104.788 121.453 103.598 123.993 102.974 126.696C102.752 127.581 102.598 128.482 102.512 129.39",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M119.96 42C119.96 42 120.668 54.6 121.16 60.78C121.652 66.96 121.862 76.596 121.904 82.908C121.946 89.22 121.178 97.146 120.746 98.868C120.371 100.202 119.906 101.509 119.354 102.78",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M132.434 43.29C131.841 44.0333 131.414 44.8951 131.182 45.8173C130.95 46.7395 130.919 47.7006 131.09 48.636C131.756 51.636 134.852 68.472 134.846 70.908C134.84 73.344 135.02 94.518 135.068 95.952C135.116 97.386 134.102 102.21 133.622 104.124",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M145.844 64.326C145.844 64.326 143.552 64.56 144.044 68.148C144.536 71.736 145.7 83.394 145.7 86.64C145.7 89.886 146.456 97.392 146.3 104.466C146.144 111.54 147.806 114 148.574 115.8",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M110.444 111.51C110.444 111.51 109.628 115.572 110.726 117.672C111.824 119.772 113.348 124.224 113.342 126.672",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M118.664 109.506C118.664 109.506 118.232 112.854 118.706 115.002C119.122 116.547 119.782 118.016 120.662 119.352",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M132.374 114.774C132.374 114.774 131.894 118.314 132.752 120.558C133.268 121.913 133.89 123.225 134.612 124.482",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M113.9 299.484L151.742 214.098C151.742 214.098 135.608 200.766 124.988 193.8C114.368 186.834 101.636 187.014 101.636 187.014C101.636 187.014 85.0101 222.444 84.1341 224.7C83.2581 226.956 71.6661 250.962 71.6661 250.962C71.6661 250.962 66.5721 252.762 64.3101 256.848C62.5401 260.04 49.7721 287.7 44.3301 299.514L113.9 299.484Z",
    fill: "#657B8D",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M140.693 219.694C142.37 218.703 142.926 216.539 141.934 214.862C140.942 213.185 138.778 212.629 137.101 213.621C135.424 214.613 134.868 216.776 135.86 218.454C136.852 220.131 139.016 220.686 140.693 219.694Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M136.988 230.712C136.819 231.389 136.452 232.001 135.935 232.469C135.418 232.938 134.773 233.243 134.083 233.345C133.393 233.448 132.687 233.343 132.056 233.044C131.426 232.746 130.897 232.267 130.539 231.668C130.18 231.069 130.007 230.378 130.042 229.681C130.077 228.983 130.317 228.312 130.733 227.752C131.149 227.192 131.722 226.767 132.38 226.533C133.037 226.298 133.749 226.264 134.426 226.434C134.875 226.546 135.298 226.746 135.67 227.022C136.042 227.298 136.356 227.644 136.594 228.042C136.832 228.439 136.99 228.879 137.057 229.338C137.125 229.796 137.101 230.263 136.988 230.712Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighFiveHandsBro);
export default __webpack_public_path__ + "static/media/highFiveHandsBro.1568171c4ef24f3f115f1fe12e7c580e.svg";
export { ForwardRef as ReactComponent };